module.exports = __webpack_public_path__ + "img/teacherTrain-4.09fe938d.jpg";